import { jsonFetch } from "@/lib/helpers";
import { ManufacturerMonitorData } from "@/models";
import { GET_LEXEON_DEVICE_DATA } from "./api-url.constants";
import { GetLexeonDeviceDataResponseApiDto } from "./dtos";
import { mapLexeonDeviceDataDTOToManufacturerMonitorData } from "./mappers/lexeon-device-data-dto-to-manufacturer-monitor-data.mapper";

interface GetLexeonDeviceDataParams {
  from: number;
}

export const getLexeonDeviceData = async ({
  from,
}: GetLexeonDeviceDataParams): Promise<ManufacturerMonitorData[]> => {
  const lexeonDeviceDataDTO = await jsonFetch<GetLexeonDeviceDataResponseApiDto>(
    `${GET_LEXEON_DEVICE_DATA}?from=${from}`
  );
  return mapLexeonDeviceDataDTOToManufacturerMonitorData(lexeonDeviceDataDTO);
};
